import {useOverlay} from "../overlay/OverlayContext";
import {usePlayers} from "./PlayerContext";
import {PlayerDetails} from "../interfaces";
import React from "react";

// Still wip
export default function PlayerList(props: PlayerListProps){

    const players = usePlayers()
    const overlay = useOverlay()

    const handleClick = (e: React.MouseEvent, steamId: string) => {
        if (e.target !== e.currentTarget) {
            return
        }

        if (props.onPlayerClick){
            props.onPlayerClick(steamId)
        }
        else{
            overlay.openPlayerOverlay(steamId)
        }
    }

    return (<>
        <div className="flex overflow-y-auto h-full rounded-md bg-neutral-900 [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:rounded-md [&::-webkit-scrollbar-track]:bg-neutral-600
            [&::-webkit-scrollbar-thumb]:rounded-md [&::-webkit-scrollbar-thumb]:bg-neutral-400 border border-neutral-600">
            <div className="w-full min-h-[50px] flex-grow">
                {players.online.length === 0 && (
                    <div className="flex items-center justify-center h-full text-center">
                        <i>No players online<br />¯\_(ツ)_/¯</i>
                    </div>
                )}
                <ul className="">
                    {players.online.map(p => (
                        <li className="w-full px-2 py-1 border-neutral-700 even:bg-neutral-800 cursor-pointer"
                            key={p.steamId} onClick={e => handleClick(e, p.steamId)}>
                            {props.rowMapper ? props.rowMapper(p) : p.displayName}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    </>)
}

interface PlayerListProps{
    onPlayerClick?: (steamId: string) => void
    rowMapper?: (p: PlayerDetails) => React.ReactNode
}